import { use_slice_ui } from '@/hooks/store/use_slices';

export function GRID2D_GALLERY__image_empty() {
  const { global__grid2d_gallery_cell_current } = use_slice_ui(['global__grid2d_gallery_cell_current']);

  if (!global__grid2d_gallery_cell_current.is_stub()) return null;

  return <div className="size-full flex-center text-bar-foreground">No image</div>;
}
